exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-popper.tag_select-popper .el-select-dropdown__item{height:100%!important;padding:0}.text-color{color:var(--systemMainColor)}", ""]);

// exports
